import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Button,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid2";
import instance from "../../Utils/api";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const Suborderstatus = ({ setstatusDialog, statusDialog, selectedsubOrder, setReload, setgetOrder }) => {
    //handle close
    const handleClose = () => {
        setstatusDialog(false);
        //empty the values
        SetSubOrderStatus('')
    };
    //handle change suborder status
    const [suborderStatus, SetSubOrderStatus] = useState('');
    useEffect(()=>{
        SetSubOrderStatus(selectedsubOrder?.status);
    },[selectedsubOrder])
    const handleSubOrderStatus = async (selectedsubOrder) => {
        // console.log("hii")

        try {
            const response = await instance.patch('/Order/changeSubOrderStatus',
                {
                    order_id: selectedsubOrder._id, // Use `selectedOrder` to access `order_id`
                    status: suborderStatus
                }
            )

            if (response.data.success === true) {
                toast.success(response.data.message)
                handleClose();
                setReload((prev) => !prev); // Toggle reload state
                setgetOrder(true)
            } else {
                toast.error(response.data.message)
            }
        } catch (error) {
            toast.error(error?.response?.data?.message)
        }
    }

    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={statusDialog}
                className="admin-admins"
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Edit Suborder status
                    <Typography>Edit your sub order status</Typography>
                </DialogTitle>
                <hr style={{ margin: "10px 0px" }} />
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <section className="add-admin">
                        <Grid container spacing={2}>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                <div className='admin-textfiled'>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Select SubOrder Status</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            label="Select SubOrder Status"
                                            required
                                            placeholder="Select SubOrder Status"
                                            fullWidth
                                            value={suborderStatus}
                                            onChange={(e) => SetSubOrderStatus(e.target.value)}
                                        >
                                            <MenuItem value="In Progress">In Progress</MenuItem>
                                            <MenuItem value="Completed">Completed</MenuItem>
                                            <MenuItem value="Canceled">Canceled</MenuItem>
                                            {/* <MenuItem value="In Transit">In Transit</MenuItem> */}
                                            {/* <MenuItem value="In Payment">In Payment</MenuItem> */}
                                            {/* <MenuItem value="Delivered">Delivered</MenuItem> */}
                                        </Select>
                                    </FormControl>
                                </div>
                            </Grid>
                        </Grid>
                    </section>
                </DialogContent>

                <DialogActions>
                    <Button className="cancel-btn" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button className="add-btn" onClick={() => handleSubOrderStatus(selectedsubOrder)}>change Status</Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    )
}

export default Suborderstatus;